import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Async thunk to fetch phone number
export const fetchPhoneNumber = createAsyncThunk(
  'phoneNumber/fetchPhoneNumber',
  async () => {
    const response = await axiosInstance.post(
      '/api/Common/GetWebsiteSettings',
      { websiteType: 7 },
      {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      }
    );
    // Parse and return the JSON message from the response
    return JSON.parse(response.data.message);
  }
);

// PhoneNumber slice
const phoneNumberSlice = createSlice({
  name: 'phoneNumber',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPhoneNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPhoneNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Selectors
export const selectPhoneNumber = (state) => state.phoneNumber.data;
export const selectPhoneNumberLoading = (state) => state.phoneNumber.loading;
export const selectPhoneNumberError = (state) => state.phoneNumber.error;

export default phoneNumberSlice.reducer;
